// extracted by mini-css-extract-plugin
export default {"moreInfo":"morebookinfo_moreInfo__Zllkz","pageContent":"morebookinfo_pageContent__UJThJ"};